'use client'

import { useTranslation } from 'src/utils/i18n'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { appendSetupQuery } from 'src/utils/resolveCurrentOrderId'

const Start = ({ setCurrentItem }) => {
  const { t } = useTranslation('commonAndroid')
  const router = useRouter()

  const goWithOrderId = path => {
    router.push(appendSetupQuery(path))
  }

  return (
    <div className='flex flex-col items-center h-auto pb-[100px]'>
      <p className='text-[24px] leading-[32px] Dsm:text-[18px] Dsm:leading-[24px] font-[600] text-[#2B2D33] max-w-[752px] mx-auto text-center mt-[60px]'>
        {t('Can you download the app on an Android device')}?
      </p>
      <div className='mt-6 mb-10 mx-auto w-[334px] bg-white rounded-[8px] p-3 flex items-start [box-shadow:0px_1px_6px_0px_#28293826]'>
        <Image src={'/warn.svg'} width={24} height={24} alt='' />
        <p className='ml-3 text-[14px] leading-[22px] text-[#282938]'>
          {t('No need to use the target phone any Android you have can be used to connect the target Google accounts')}
        </p>
      </div>
      <button className='w-[334px] h-auto px-[20px] py-[24px] border-[#4A77FE] border-[1px] rounded-[10px] mx-auto bg-[#F7FAFF99] hover:bg-[#2A99FF26] flex items-center'
        onClick={() => goWithOrderId('/android/setup')}>
        <Image src={'/image/good.svg'} width={48} height={48} alt='' />
        <span className='text-[16px] leading-[24px] text-[#282938] ml-2 text-start'>
          {t('I can use an Android device')}<br />({t('Need download Google Account Verification')})
        </span>
      </button>
      <button className='w-[334px] h-auto px-[20px] py-[24px] border-[#4A77FE] border-[1px] rounded-[10px] mt-[24px] mx-auto bg-[#F7FAFF99] hover:bg-[#2A99FF26] flex items-center'
        onClick={() => goWithOrderId('/android/nodevice-setup')}>
        <Image src={'/image/bad.svg'} width={48} height={48} alt='' />
        <span className='text-[16px] leading-[24px] text-[#282938] ml-2 text-start'>
          {t('I cant download the app')}<br />({t('still need the device for two-step verification')})
        </span>
      </button>
      <div className='w-full mx-auto fixed bottom-0 bg-white border-t-[1px] border-[#E5E7EB]'>
        <div className='flex justify-center w-full p-5 Mlg:px-0 bg-white mx-auto'>
          <div className='w-full lg:w-[620px] flex justify-between smj:px-4'>
            <button onClick={() => setCurrentItem('First')}
              className='border-[1px] border-[#454CFF] bg-white rounded-[24px] h-[35px] flex items-center pl-[10px] pr-[19px]'>
              <Image className='mr-[7px]' src='/images/bind/bind-arrow-blue.svg' width={18} height={18} alt='back' />
              <span className='text-[15px] text-[#454CFF] font-[600]'>{t('BACK')}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Start
